import type { SellerPublicSummary } from '@redevicer/shared'

interface Props {
  seller?: SellerPublicSummary | null
  sellerCity?: string | null
}

export default function ListingCardSellerLine({ seller, sellerCity }: Props) {
  const name = seller?.display_name?.trim()
  const city = sellerCity?.trim()
  const empty = !name && !city

  return (
    <p
      className={`listing-card-seller${empty ? ' listing-card-seller--placeholder' : ''}`}
      aria-hidden={empty || undefined}
    >
      {name ? <span className="listing-card-seller-name">{name}</span> : null}
      {name && city ? (
        <span className="listing-card-seller-sep" aria-hidden="true">
          {' · '}
        </span>
      ) : null}
      {city ? <span className="listing-card-seller-city">{city}</span> : null}
      {empty ? <span className="listing-card-seller-name">&nbsp;</span> : null}
    </p>
  )
}
